import StyledSelect from "./StyledSelect"

export default class CountryPhonesSelect extends StyledSelect
{
    protected switchDisplayedValue(box: Element)
    {
        let value = box.querySelector('.' + this.classes.value) as HTMLElement;
        let image = this.getSelectedDataAttribute(box, 'image').pop();

        if (image) {
            value.style.backgroundImage = 'url(' + image + ')';
        } else {
            value.style.backgroundImage = '';
        }
    }

    protected valueSelected(box: HTMLElement, listItem: HTMLElement): void
    {
        this.selectValue(box, listItem);
    }
}
